var map = {
	"./account.js": 3509,
	"./address.js": 3510,
	"./appFaq.js": 3511,
	"./bindForm.js": 3512,
	"./bm.js": 3513,
	"./classChangeRules.js": 3514,
	"./common.js": 3515,
	"./cookiesPolicy.js": 3516,
	"./courses.js": 3517,
	"./coursesDetail.js": 3518,
	"./download.js": 3519,
	"./editlInfo.js": 3520,
	"./evaluation.js": 3521,
	"./faq.js": 3522,
	"./goods.js": 3523,
	"./home.js": 3524,
	"./index.js": 3507,
	"./levelTest.js": 3528,
	"./login.js": 3529,
	"./order.js": 3530,
	"./ourCourses.js": 3531,
	"./page.js": 3532,
	"./privacyPolicy.js": 3533,
	"./refundPolicy.js": 3534,
	"./resources.js": 3535,
	"./safeguardingPolicy.js": 3536,
	"./seo.js": 3537,
	"./shortTermCourse.js": 3538,
	"./taxStrategy.js": 3539,
	"./teacher.js": 3540,
	"./termsAndConditions.js": 3541,
	"./termsOfRefund.js": 3542,
	"./termsOfUse.js": 3543,
	"./test.js": 3544,
	"./tutors.js": 3545,
	"./unpaidCourses.js": 3546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3508;